import { NgModule } from '@angular/core';
import { IsolatedHtmlComponent } from './components/isolated-html/isolated-html.component';
import { LoginComponent } from './components/login/login.component';
import { MarkdownEditorComponent } from './components/markdown-editor/markdown-editor.component';
import { MarkdownEditorSingleLineComponent } from './components/markdown-editor-single-line/markdown-editor-single-line.component';
import { ProficiencyIconComponent } from './components/icons/proficiency-icon/proficiency-icon.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgbDatepickerModule, NgbModalModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { MembershipIconComponent } from './components/icons/membership-icon/membership-icon.component';
import { SimpleMessageModalComponent } from './components/modals/simple-message-modal/simple-message-modal.component';
import { MedicalNotesIconComponent } from './components/icons/medical-notes-icon/medical-notes-icon.component';
import { AlertIconComponent } from './components/icons/alert-icon/alert-icon.component';
import { RefreshIconComponent } from './components/icons/refresh-icon/refresh-icon.component';
import { ManualBarcodeEntryModalComponent } from './components/modals/manual-barcode-entry-modal/manual-barcode-entry-modal.component';
import { DatabaseMaintenanceModalComponent } from './components/modals/database-maintenance-modal/database-maintenance-modal.component';
import { PinModalComponent } from './components/modals/pin-modal/pin-modal.component';
import { CommonModule } from '@angular/common';
import { CapitanDatePickerComponent } from './components/date-picker/date-picker.component';
import { IdListSelectorComponent } from './components/id-list-selector/id-list-selector.component';
import { NgxBarCodePutDirective } from './barcode-put.directive';

@NgModule({
  declarations: [
    IsolatedHtmlComponent,
    LoginComponent,
    MarkdownEditorComponent,
    MarkdownEditorSingleLineComponent,
    ProficiencyIconComponent,
    MembershipIconComponent,
    MedicalNotesIconComponent,
    AlertIconComponent,
    RefreshIconComponent,
    SimpleMessageModalComponent,
    ManualBarcodeEntryModalComponent,
    DatabaseMaintenanceModalComponent,
    PinModalComponent,
    CapitanDatePickerComponent,
    IdListSelectorComponent,
    NgxBarCodePutDirective,
  ],
  exports: [
    IsolatedHtmlComponent,
    LoginComponent,
    MarkdownEditorComponent,
    MarkdownEditorSingleLineComponent,
    ProficiencyIconComponent,
    MembershipIconComponent,
    MedicalNotesIconComponent,
    AlertIconComponent,
    RefreshIconComponent,
    SimpleMessageModalComponent,
    ManualBarcodeEntryModalComponent,
    DatabaseMaintenanceModalComponent,
    PinModalComponent,
    CapitanDatePickerComponent,
    IdListSelectorComponent,
    NgxBarCodePutDirective,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    DragDropModule,
    NgbDatepickerModule,
    NgbTooltipModule,
    NgbTypeaheadModule,
    NgbModalModule,
  ]
})
export class CapitanCommonModule {}
